const mockQuestions = {
    "freelance-agreement": [
      {
        id: "freelancer-name",
        label: "What is the freelancer's full name?",
        type: "text",
        placeholder: "Enter freelancer's name",
      },
      {
        id: "client-name",
        label: "What is the client's company name?",
        type: "text",
        placeholder: "Enter client's company name",
      },
      {
        id: "project-scope",
        label: "Describe the project scope.",
        type: "textarea",
        placeholder: "Include deliverables and timelines",
      },
      {
        id: "payment-amount",
        label: "What is the payment amount?",
        type: "number",
        placeholder: "Enter amount",
      },
      {
        id: "payment-due",
        label: "When is the payment due?",
        type: "date",
        placeholder: "",
      },
    ],
    "nda": [
      {
        id: "disclosing-party",
        label: "Who is the disclosing party?",
        type: "text",
        placeholder: "Enter the name of the party sharing information",
      },
      {
        id: "receiving-party",
        label: "Who is the receiving party?",
        type: "text",
        placeholder: "Enter the name of the party receiving information",
      },
      {
        id: "purpose",
        label: "What is the purpose of the NDA?",
        type: "textarea",
        placeholder: "Describe why confidentiality is needed",
      },
      {
        id: "duration",
        label: "How long should the confidentiality last?",
        type: "number",
        placeholder: "Enter duration in years",
      },
    ],
    "terms-and-conditions": [
      {
        id: "business-name",
        label: "What is your business name?",
        type: "text",
        placeholder: "Enter your business name",
      },
      {
        id: "website-url",
        label: "What is your website URL?",
        type: "text",
        placeholder: "Enter your website address",
      },
      {
        id: "services",
        label: "Describe your services or products",
        type: "textarea",
        placeholder: "List the services or products your business offers",
      },
      {
        id: "governing-law",
        label: "Which country's laws govern these terms?",
        type: "text",
        placeholder: "Enter country name",
      },
    ],
    "employment-contract": [
      {
        id: "employer-name",
        label: "What is the employer's name?",
        type: "text",
        placeholder: "Enter employer's name",
      },
      {
        id: "employee-name",
        label: "What is the employee's name?",
        type: "text",
        placeholder: "Enter employee's name",
      },
      {
        id: "position",
        label: "What is the job position?",
        type: "text",
        placeholder: "Enter job title or position",
      },
      {
        id: "salary",
        label: "What is the annual salary?",
        type: "number",
        placeholder: "Enter annual salary amount",
      },
      {
        id: "start-date",
        label: "When does employment begin?",
        type: "date",
        placeholder: "",
      },
    ],
    "privacy-policy": [
      {
        id: "company-name",
        label: "What is your company name?",
        type: "text",
        placeholder: "Enter your company name",
      },
      {
        id: "website-url",
        label: "What is your website URL?",
        type: "text",
        placeholder: "Enter your website address",
      },
      {
        id: "data-collected",
        label: "What personal data do you collect?",
        type: "textarea",
        placeholder: "List types of data you collect (e.g., name, email, location)",
      },
      {
        id: "data-use",
        label: "How do you use the collected data?",
        type: "textarea",
        placeholder: "Explain how you use personal data",
      },
      {
        id: "third-parties",
        label: "Do you share data with third parties?",
        type: "text",
        placeholder: "Yes/No and with whom if applicable",
      },
    ],
    "rental-agreement": [
      {
        id: "landlord-name",
        label: "What is the landlord's full name?",
        type: "text",
        placeholder: "Enter landlord's name",
      },
      {
        id: "tenant-name",
        label: "What is the tenant's full name?",
        type: "text",
        placeholder: "Enter tenant's name",
      },
      {
        id: "property-address",
        label: "What is the rental property address?",
        type: "textarea",
        placeholder: "Enter complete property address",
      },
      {
        id: "rent-amount",
        label: "What is the monthly rent amount?",
        type: "number",
        placeholder: "Enter amount in dollars",
      },
      {
        id: "lease-start",
        label: "When does the lease begin?",
        type: "date",
        placeholder: "",
      },
      {
        id: "lease-end",
        label: "When does the lease end?",
        type: "date",
        placeholder: "",
      },
    ],
    "cease-and-desist": [
      {
        id: "sender-name",
        label: "What is the sender's full name?",
        type: "text",
        placeholder: "Enter your full name",
      },
      {
        id: "recipient-name",
        label: "What is the recipient's name?",
        type: "text",
        placeholder: "Enter recipient's name or company",
      },
      {
        id: "recipient-address",
        label: "What is the recipient's address?",
        type: "textarea",
        placeholder: "Enter recipient's complete address",
      },
      {
        id: "violation-description",
        label: "Describe the violation or infringement",
        type: "textarea",
        placeholder: "Provide details about the unauthorized activity",
      },
      {
        id: "demand-action",
        label: "What action are you demanding?",
        type: "textarea",
        placeholder: "Specify what you want the recipient to do or stop doing",
      },
      {
        id: "deadline",
        label: "By when must they comply?",
        type: "date",
        placeholder: "",
      },
    ],
    "invoice-template": [
      {
        id: "business-name",
        label: "What is your business name?",
        type: "text",
        placeholder: "Enter your business name",
      },
      {
        id: "client-name",
        label: "Who is the client?",
        type: "text",
        placeholder: "Enter client name or company",
      },
      {
        id: "invoice-number",
        label: "What is the invoice number?",
        type: "text",
        placeholder: "Enter invoice number (e.g., INV-001)",
      },
      {
        id: "issue-date",
        label: "What is the issue date?",
        type: "date",
        placeholder: "",
      },
      {
        id: "due-date",
        label: "When is payment due?",
        type: "date",
        placeholder: "",
      },
      {
        id: "services-provided",
        label: "What services or products are you billing for?",
        type: "textarea",
        placeholder: "List items, quantities, and prices",
      },
      {
        id: "total-amount",
        label: "What is the total amount due?",
        type: "number",
        placeholder: "Enter total amount",
      },
    ],
  };
  
  export default mockQuestions;